// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3XtVQ","approved":"Status_approved__j73II","rejected":"Status_rejected__1Os_N","expired":"Status_expired__2I4ZI","label":"Status_label__1Zm36"};